import React, { Component } from 'react'
import './AdditionalDetails.css'
import Axios from '../../../../Axios'
import { Urls } from '../../../../Urls'
import Locked from '../../../Locked/Locked'
// let otherBusinessInterest = 'Details not available'
// class AdditionalDetails extends Component {
//     constructor(props) {
//         super(props)

//         this.state = {
//             Documents: 'Details not available'
//         }
//     }

//     // componentWillReceiveProps(nextProps){
//     //     otherBusinessInterest=nextProps.transporter_data.other_business_interest;
//     //     if(otherBusinessInterest==undefined || otherBusinessInterest==null){
//     //         otherBusinessInterest='Details not available'

//     //     }
//     // }

//     static getDerivedStateFromProps(nextProps, prevState) {
//         // otherBusinessInterest=nextProps.transporter_data.other_business_interest;
//         // if(otherBusinessInterest==undefined || otherBusinessInterest==null){
//         //     otherBusinessInterest='Details not available'

//         console.log(nextProps)

//         // }
//         if (nextProps.transporter_data.additional_attachments === undefined || nextProps.transporter_data.additional_attachments?.length === 0) {
//             return {
//                 Documents: 'Details not available'
//             }
//         }
//         else {
//             return {
//                 Documents: nextProps.transporter_data.other_business_interest
//             }
//         }
//     }

//     render() {
        
//     }
// }


const AdditionalDetails = ({transporter_data}) => {

const documents = transporter_data?.additional_attachments

const handleFileDownload = (file) => {
    let body = {
        'action': 'download',
        // 'accountName': 'lorrifilesproduction',
        'accountName':process.env.REACT_APP_STORAGE_ACCOUNT,
        'containerName': 'private-container',
        'fileName': file.blob_url
    }
    Axios.post(Urls.fileService, body)
        .then(res => {
            window.open(res.data.url, "_blank")
        })
        .catch(err => {
            console.log(err)
        })
}

    return (
        <>
            <div className="othercard">
                <div className="othercontainer row">
                    <div className="col-12">
                        <h3 className="data_header">Additional Details</h3>
                    </div>
                    <div className="col-12">
                        {documents?.map((document)=>{
                            return(
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                            <div>
                                <p>{document.name}</p>
                            </div>
                            <div>
                                <button className='btn'><Locked/></button>
                            </div>
                        </div>
                            )
                        })}
                        
                    </div>
                </div>
            </div>
        </>
    )
}

export default AdditionalDetails
